import { TabType } from '@/components/common/TagTabs/TagTabs';
import ActionsContainer from './Billing/Billing.container';
import HistoryContainer from './History/History.container';
import NotesContainer from './Notes/Notes.container';

export const rightPanelTabs: TabType[] = [
  {
    title: 'Actions',
    name: 'ACTIONS',
    ContentComponent: ActionsContainer
  },
  {
    title: 'History',
    name: 'HISTORY',
    ContentComponent: HistoryContainer
  },
  {
    title: 'Notes',
    name: 'NOTES',
    ContentComponent: NotesContainer
  }
];
